// Token store panra time, expiry timestamp um kooda vekkurom (24 hours)
const TOKEN_TTL_MS = 24 * 60 * 60 * 1000 // 24 hours

export const saveAuth = (token, user, remember) => {
  const expiryAt = Date.now() + TOKEN_TTL_MS
  const storage = remember ? localStorage : sessionStorage

  storage.setItem('token', token)
  storage.setItem('user', JSON.stringify(user))
  storage.setItem('tokenExpiry', String(expiryAt))
}

export const getToken = () => {
  return localStorage.getItem('token') || sessionStorage.getItem('token')
}

export const getUser = () => {
  const raw = localStorage.getItem('user') || sessionStorage.getItem('user')
  return raw ? JSON.parse(raw) : null
}

export const clearAuth = () => {
  localStorage.removeItem('token')
  localStorage.removeItem('user')
  localStorage.removeItem('tokenExpiry')
  sessionStorage.removeItem('token')
  sessionStorage.removeItem('user')
  sessionStorage.removeItem('tokenExpiry')
}

// Token irukka + expire aagala nu check pandra function
export const isTokenValid = () => {
  const token =
    localStorage.getItem('token') || sessionStorage.getItem('token')
  const expiry =
    localStorage.getItem('tokenExpiry') || sessionStorage.getItem('tokenExpiry')

  if (!token || !expiry) return false

  const isExpired = Date.now() > Number(expiry)

  if (isExpired) {
    clearAuth() // expired na immediately clear pannidum
    return false
  }

  return true
}